import { render, staticRenderFns } from "./BangGiaQuangCaoList.vue?vue&type=template&id=4a05f74c"
import script from "./BangGiaQuangCaoList.vue?vue&type=script&lang=js"
export * from "./BangGiaQuangCaoList.vue?vue&type=script&lang=js"
import style0 from "./BangGiaQuangCaoList.vue?vue&type=style&index=0&id=4a05f74c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports